import { render, staticRenderFns } from "./feedbackOptionsControl.vue.js?vue&type=template&id=32806c33!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./feedbackOptionsControl.vue?vue&type=template&id=32806c33"
import script from "./feedbackOptionsControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./feedbackOptionsControl.vue?vue&type=script&lang=js"
export * from "./feedbackOptionsControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./feedbackOptionsControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports